import { Injectable } from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {Actions} from "../core/models/models";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private authService: AuthenticationService) { }

  private isPermittedForAction(action: Actions): boolean {
    if (this.authService.getUser() == undefined) {
      return false;
    }

    if (this.authService.getUser() == null) {
      return false;
    }
    return this.authService.getUser()!.allowed_actions.permissions.includes(action);
  }

  isAdmin(): boolean {
    return this.isPermittedForAction(Actions.ADMIN_UI);
  }

  mayEventCreate(): boolean {
    return this.isPermittedForAction(Actions.EVENTS_CREATE);
  }

  mayEventListWithNonLive(): boolean {
    return this.isPermittedForAction(Actions.EVENTS_LIST_NON_LIVE);
  }

  mayEventUpdate(): boolean {
    return this.isPermittedForAction(Actions.EVENTS_UPDATE);
  }

  mayEventGoLive(): boolean {
    return this.isPermittedForAction(Actions.EVENTS_GO_LIVE);
  }

  mayEventEvaluate(): boolean {
    return this.isPermittedForAction(Actions.VOTES_EVALUATE);
  }

  mayUploadYoutubeMemberList(): boolean {
    return this.isPermittedForAction(Actions.YOUTUBE_MEMBERS_LIST_UPLOAD);
  }

  maySendEmailNewsletter(): boolean {
    return this.isPermittedForAction(Actions.EMAIL_SEND);
  }

  mayAdminResetSeason(): boolean {
    return this.isPermittedForAction(Actions.ADMIN_RESET);
  }

  mayAdminPatreonSeason(): boolean {
    return this.isPermittedForAction(Actions.ADMIN_PATREON_SEASON);
  }

  mayAdminUploadBanner(): boolean {
    return this.isPermittedForAction(Actions.ADMIN_UPLOAD_BANNER);
  }
}
